interface DiagnosticHeaderProps {
  children: React.ReactNode
}

export default function DiagnosticHeader({ children }: DiagnosticHeaderProps) {
  return <div className="flex h-fit w-full">{children}</div>
}
